import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import {
  ClimateStatement,
  EnergyStatement,
  EnergyStatementCache,
  EnergyStatementExcel,
  ClimateStatementExcel,
  TariffStatementExcel,
  PricesStatement,
  SpotPricesStatement,
  TariffStatement,
} from "@/pages";
import React from "react";
import { permissionsEnergyStatement } from "@/utils";

const parentPath = "statement";

/**
 * Route definitions for statement and reporting routes.
 * Provides access to various energy and climate statements and price data.
 */
export const statementRoutes: React.ReactElement<any>[] = [
  <Route
    key="energy"
    path="energy"
    element={
      <ProtectedRoute
        element={(<EnergyStatementExcel />) as React.ReactElement<any>}
        codes={permissionsEnergyStatement}
      />
    }
  />,

  <Route
    key="energy-old"
    path="energy-old"
    element={
      <ProtectedRoute
        element={(<EnergyStatement />) as React.ReactElement<any>}
        codes={permissionsEnergyStatement}
      />
    }
  />,

  <Route
    key="climate"
    path="climate"
    element={
      <ProtectedRoute
        element={(<ClimateStatementExcel />) as React.ReactElement<any>}
        codes={permissionsEnergyStatement}
      />
    }
  />,

  <Route
    key="climate-old"
    path="climate-old"
    element={
      <ProtectedRoute
        element={(<ClimateStatement />) as React.ReactElement<any>}
        codes={permissionsEnergyStatement}
      />
    }
  />,

  <Route
    key="tariff"
    path="tariff"
    element={
      <ProtectedRoute
        element={(<TariffStatementExcel />) as React.ReactElement<any>}
        codes={permissionsEnergyStatement}
      />
    }
  />,

  <Route
    key="tariff-old"
    path="tariff-old"
    element={
      <ProtectedRoute
        element={
          (
            <TariffStatement parentPath={parentPath} />
          ) as React.ReactElement<any>
        }
        codes={permissionsEnergyStatement}
      />
    }
  />,

  <Route
    key="spot-prices"
    path="spot-prices"
    element={
      <ProtectedRoute
        element={
          (
            <SpotPricesStatement parentPath={parentPath} />
          ) as React.ReactElement<any>
        }
        codes={permissionsEnergyStatement}
      />
    }
  />,

  <Route
    key="prices"
    path="prices"
    element={
      <ProtectedRoute
        element={
          (
            <PricesStatement parentPath={parentPath} />
          ) as React.ReactElement<any>
        }
        codes={permissionsEnergyStatement}
      />
    }
  />,

  <Route
    key="cache"
    path="cache"
    element={
      <ProtectedRoute
        element={(<EnergyStatementCache />) as React.ReactElement<any>}
        codes={permissionsEnergyStatement}
      />
    }
  />,
];
